angular.module(NgAppName).component('crWelcomeSearch', {
	templateUrl: 'crWelcomeSearch.html',
	bindings: {
		activeSearch: '@',
		type: '@',
		recentSearchesUrl: '@',
		recentSearchRedirectionUrl: '@',
		autocompleteUrl: '@',
		autocompleteSubmitUrl: '@',
		buildingSearchUrl: '@',
		buttonText: '@',
		searchBuyApartmentsUrl: '@',
		searchRentApartmentsUrl: '@',
		searchBuyResultsUrl: '@',
		searchRentResultsUrl: '@',
		listingsSearchFormUrl: '@',
		placeholderDefault: '@',
		placeholderAutocomplete: '@'
	},
	controller: ['$element', '$window', '$document', '$interval', '$cookies', '$http', '$timeout', '$q', 'gVariables', 'PubSub', 'windowEvents', 'crResourcesService', function($element, $window, $document, $interval, $cookies, $http, $timeout, $q, gVariables, PubSub, windowEvents, crResourcesService) {
		var self = this;

		this.searchDelay = 500;
		this.trackingDelay = 100;
		this.lastSearch = 'searchsales'; 

		this.orderRegions = {
			'Upper East Side': 3,
			'Upper West Side': 4,
			'Midtown': 2,
			'Downtown': 1,
			'Financial District/BPC': 5,
			'Upper Manhattan': 7,
			'Brooklyn': 6,
			'LIC / Queens': 8,
			'The Bronx': 9
		};


		this.noMatchesWording = "No matches found. Try a different keyword or select a neighborhood from below to start.";
		if (this.type === 'for-sale') {
			this.noMatchesWording = "No matches found. Please try a different keyword.";
		}

		this.$onInit = () => {
			// this.welcomeSearch = "Condo in Upper East Side or Midtown";
			this.welcomeSearch = '';
			this.defaultPlaceholder = this.placeholderDefault || 'Search by address';

			// this.placeholderAuto = this.placeholderAutocomplete.replace(/'/g, '"');

			this.placeholderAuto = this.defaultPlaceholder;

			this.categoryTrack = this.type === 'top-nav' ? 'Topnav-search' : 'Home-search';
			this.searchInProgress = false;
 
			// Causing an issue on the dropdown when clicking links
			// var form = $element[0].querySelector('form');
			// form.addEventListener('focusout', e => {
			// 	const isFocusOut = Core.isFocusOutFromParent(e, form);
			// 	if(isFocusOut) {
			// 		$timeout(() => {
			// 			this.searching = false;
			// 		});
			// 	}
			// })

			// click outside the form restore the default view
			$document.on('click', (e) => {
				let inputContainer = $element[0].querySelector('.input-container');
				let welcomeSearchFilters = $element[0].querySelector('.welcome-search-filters');
				let welcomeSearchResults = $element[0].querySelector('.results');
				// let typeContainer = $element[0].querySelector('.type-container');
				// let priceContainer = $element[0].querySelector('.price-container');
				let clickOutsideAutocomplete = inputContainer && inputContainer !== e.target && !inputContainer.contains(e.target);
				let clickOutsideFilters = welcomeSearchFilters ? welcomeSearchFilters !== e.target && !welcomeSearchFilters.contains(e.target) : true;
				let clickOutsideResults = welcomeSearchResults ? welcomeSearchResults !== e.target && !welcomeSearchResults.contains(e.target) : true;
				// let clickOutsideType = typeContainer && typeContainer !== e.target && !typeContainer.contains(e.target);
				// let clickOutsidePrice = priceContainer && priceContainer !== e.target && !priceContainer.contains(e.target);
				if (clickOutsideAutocomplete && clickOutsideFilters && clickOutsideResults) {
					$timeout(() => {

						if (!this.open) {
							this.searching = false;
						}
					

						this.tmpWelcomeSearch = this.welcomeSearch;

						if (this.type !== 'for-sale') {
							this.welcomeSearch = '';
						}

						this.placeholderAuto = this.defaultPlaceholder;
					});
				}
			});

			// get recent searches
			crResourcesService.get(this.recentSearchesUrl).$promise.then((data) => {
				if (data && data.items) { 
					// this.recentSearches = data.items;
					this.recentSearchesBuildings = data.items.building;
					this.recentSearchesHoods = data.items.hood;
				}

				// TO REMOVE : the delete functionnality does not longer exist
				// PubSub.subscribe('delete-recent-search', this.deleteRecentSearches);
			});

			let arrayPromises = [];

			// get sales filters
			let promiseFilterSales = crResourcesService.get(`${this.listingsSearchFormUrl}?search=autocompletesales`).$promise;
			arrayPromises.push(promiseFilterSales);
			promiseFilterSales.then((data) => {
				if (data && data.filters) {
					for (let i = 0; i < data.filters.length; i++) {
						let filter = data.filters[i];
						if (filter.name === 'hoods') {
							this.hoods = filter.options;
							for (let j = 0; j < this.hoods.length; j++) {
								if (this.welcomeSearch.indexOf(this.hoods[j].name) >= 0) {
									this.hoods[j].active = true;
								}
								this.hoods[j].order = this.orderRegions[this.hoods[j].name];
							}

							this.hoods.sort((a, b) => {
								return a.order - b.order;
							});
						}
						if (filter.name === 'price range') {
							if (this.activeSearch === 'searchrentals') {
								this.filterPriceRentals = filter;
							} else {
								this.filterPriceSales = filter;
							}
						}
						if (filter.name === 'search term') {
							if (this.activeSearch === 'searchrentals') {
								this.filterPriceRentals = filter;
							} else {
								this.filterPriceSales = filter;
							}
						}
					}
				}
			});

			if (this.type !== 'top-nav') {
				// get rentals filters (only price range)
				let promiseFilterRentals = crResourcesService.get(`${this.listingsSearchFormUrl}?search=autocompleterentals`).$promise;
				arrayPromises.push(promiseFilterRentals);
				promiseFilterRentals.then((data) => {
					if (data && data.filters) {
						for (let i = 0; i < data.filters.length; i++) {
							let filter = data.filters[i];
							if (filter.name === 'price range') {
								this.filterPriceRentals = filter;
							}
							if (filter.name === 'search term') {
								this.filterSearchRentals = filter;
							}
						}
					}
				});
			}

			// resize price slider
			angular.element($window).on('resize', (e) => {
				PubSub.publish('resizePriceRange');
			});
		};

		this.$postLink = () => {
			PubSub.subscribe('rangeSliderChangeSales', this.updatePriceRange);
			PubSub.subscribe('rangeSliderChangeRentals', this.updatePriceRange);
		};

		this.updatePriceRange = (data) => {
			if (data) {
				let label = '';
				let action = '';

				if (this.activeSearch === 'searchsales') {
					this.filterPriceSales.options.min = data.min.toInt();
					this.filterPriceSales.options.max = data.max.toInt();

					label = 'sale';
					if (data.valueChanged === 'min') {
						action = this.filterPriceSales.options.min === this.filterPriceSales.options.keys[0] ? 'Price-min' : '';
					} else if (data.valueChanged === 'max') {
						action = this.filterPriceSales.options.max === this.filterPriceSales.options.keys[this.filterPriceSales.options.keys.length-1] ? 'Price-max' : '';
					}
				} else if (this.activeSearch === 'searchrentals') {
					this.filterPriceRentals.options.min = data.min.toInt();
					this.filterPriceRentals.options.max = data.max.toInt();

					label = 'rent';
					if (data.valueChanged === 'min') {
						action = this.filterPriceRentals.options.min === this.filterPriceRentals.options.keys[0] ? 'Price-min' : '';
					} else if (data.valueChanged === 'max') {
						action = this.filterPriceRentals.options.max === this.filterPriceRentals.options.keys[this.filterPriceRentals.options.keys.length-1] ? 'Price-max' : '';
					}
				}

				this.updateResults();

				if (action && label) {
					this.sendTrack(this.categoryTrack, action, label);
				}
			}
		};

		this.deleteRecentSearches = (data) => {
			if (data.index !== -1) {
				this.recentSearches.splice(data.index, 1);
			} else {
				this.recentSearches = [];
			}
		};

		this.clickHood = (hood) => {
			// if (!this.searchInProgress
			// 	&& this.neighborhoods && this.neighborhoods.list.length === 0
			// 	&& this.properties && this.properties.list.length === 0) {
			// 	this.welcomeSearch = '';
			// 	this.modified = false;
			// }

			hood.active = !hood.active;
			
			
			// dont update input box value

			// if (hood.active) {
			// 	let comma = this.welcomeSearch ? ', ' : '';
			// 	this.welcomeSearch = this.welcomeSearch.concat(comma + hood.name);

			// 	// track select hood
			// 	let label = this.activeSearch === 'searchsales' ? 'sale' : 'rent';
			// 	this.sendTrack(this.categoryTrack, 'Select-hoods', label);
			// } else {
			// 	// remove all occurences in the field
			// 	let regExpWithComma = new RegExp(', ' + hood.name, 'ig');
			// 	let regExp = new RegExp(hood.name, 'ig');
			// 	this.welcomeSearch = this.welcomeSearch.replace(regExpWithComma, '').replace(regExp, '').trim();
			// 	// remove starting and ending commas, then trim
			// 	this.welcomeSearch = this.welcomeSearch.replace(/(^,)|(,$)/g, '').trim();
			// }

			this.updateResults();

			// if (this.welcomeSearch.length < 3) {
			// 	if (this.neighborhoods) {
			// 		this.neighborhoods.list = [];
			// 	}
			// 	if (this.properties) {
			// 		this.properties.list = [];
			// 	}
			// 	for (var i = 0; i < this.hoods.length; i++) {
			// 		this.hoods[i].active = false;
			// 	}
			// }
		};

		this.selectType = (type) => {
			this.activeSearch	= type;

			this.updateResults();

			let action = this.activeSearch === 'searchsales' ? 'Want-buy' : 'Want-rent';
			this.sendTrack(this.categoryTrack, action, '');

			// https://jira.reol.com/browse/CITY-313
			PubSub.publish('resizePriceRange'); 
		};

		this.keyup = (e) => {
			switch(e.keyCode) {
			case 13: {
				this.submitSearch();
				break;
			}
			case 8: {
				if (this.hoodToRemove) {
					let firstPart = this.welcomeSearch.substr(0, this.hoodToRemove.index).trim();
					if (firstPart[firstPart.length-1] === ',') { // remove previous comma if there is one
						firstPart = firstPart.substr(0, firstPart.length-1);
					}
					this.welcomeSearch = firstPart + this.welcomeSearch.substr(this.hoodToRemove.index + this.hoodToRemove.hood.name.length - 1);
					if (this.hoodToRemove.alone) {
						for (var i = 0; i < this.hoods.length; i++) {
							if (this.hoods[i].name === this.hoodToRemove.hood.name) {
								this.hoods[i].active = false;
								break;
							}
						}
					}
					let input = $element[0].querySelector('.welcome-autocomplete');
					let indexSelectionEnd = this.hoodToRemove.index;
					this.hoodToRemove = null;
					this.updateFieldState();

					$timeout(() => {
						input.selectionEnd = indexSelectionEnd;
					});
				}
				break;
			}
			default: {
				break;
			}
			}
		};

		this.keydown = (e) => {
			switch(e.keyCode) {
			case 8: {
				let input = $element[0].querySelector('.welcome-autocomplete');
				let selectionStart = input.selectionStart;
				let hoodFound = null;

				let hoods = this.hoods;
				for (var i = 0; i < hoods.length; i++) {
					var indexes = this.getAllIndexes(this.welcomeSearch, hoods[i].name);
					for (var j = 0; j < indexes.length; j++) {
						if (indexes[j] + hoods[i].name.length === selectionStart) {
							hoodFound = hoods[i];
							this.hoodToRemove = {
								index: indexes[j],
								hood: hoodFound,
								alone: indexes.length === 1 ? true : false
							};
							break;
						}
					}
					if (hoodFound) {
						break;
					}
				}
				break;
			}
			default: {
				break;
			}
			}
		};

		this.changeField = () => {
			this.updateFieldState();

			this.updateResults();
		};

		this.updateFieldState = () => {
			if (this.welcomeSearch) {
				this.modified = true;
			} else {
				this.modified = false;
			}

			// if (!this.welcomeSearch.length || this.welcomeSearch.length < 3) {
			// 	if (this.neighborhoods) {
			// 		this.neighborhoods.list = [];
			// 	}
			// 	if (this.properties) {
			// 		this.properties.list = [];
			// 	}
			// 	for (var i = 0; i < this.hoods.length; i++) {
			// 		let hood = this.hoods[i];
			// 		hood.active = false;
			// 		for (var j = 0; j < hood.hoods.length; j++) {
			// 			hood.hoods[j].active = false;
			// 		}
			// 	}
			// }
		};

		this.updateResults = () => {
			if (this.timeoutSearch) {
				$timeout.cancel(this.timeoutSearch);
			}


			this.searchInProgress = true;

			this.timeoutSearch = $timeout(() => {
				let encodedSearch = encodeURIComponent(this.welcomeSearch);

				let params = {
					sale_or_rent: this.activeSearch === 'searchsales' ? 1 : this.activeSearch === 'searchrentals' ? 2 : 0,
					min: this.activeSearch === 'searchsales' && this.filterPriceSales ? this.filterPriceSales.options.min : this.activeSearch === 'searchrentals' && this.filterPriceRentals ? this.filterPriceRentals.options.min : null,
					max: this.activeSearch === 'searchsales' && this.filterPriceSales ? this.filterPriceSales.options.max : this.activeSearch === 'searchrentals' && this.filterPriceRentals ? this.filterPriceRentals.options.max : null,
					zones: this.hoods.filter(d => d.active).map(d => d.hoods[0].hood_zone_id).join(',')
				};

				if (this.requestSearch) {
					this.requestSearch.$cancelRequest();
				}

				let paramBuildingSearch = '';
				if (this.type === 'for-sale') {
					paramBuildingSearch = '&search=for-sale';
				}
				this.requestSearch = crResourcesService.post2(`${this.autocompleteUrl}?properties=1&rpc=1&query=${encodedSearch}${paramBuildingSearch}`, params);
				this.requestSearch.$promise.then((data) => {
					this.neighborhoods = data.hood;4
					this.properties = data.property;
					this.urls = data.url;
 
					this.lastSearch = data.last_search || 'searchsales';

					// if (this.neighborhoods && this.neighborhoods.list.length === 0
					// 	&& this.properties && this.properties.list.length === 0) {
					// 	for (var i = 0; i < this.hoods.length; i++) {
					// 		this.hoods[i].active = false;
					// 	}
					// }

					this.searchInProgress = false;

					// track no results
					if (this.welcomeSearch.length >= 3 && this.welcomeSearch && this.neighborhoods.list.length === 0 && this.properties.list.length === 0) {
						this.sendTrack(this.categoryTrack, 'No-results', '');
					}
				});
			}, this.searchDelay);
		};

		this.calcHoods = () => {
			let hoods = angular.copy(this.hoods);
			let zones = this.neighborhoods ? this.neighborhoods.list.filter((h) => h.type === 'zone') : [];
			let neighborhoods = this.neighborhoods ? this.neighborhoods.list.filter((h) => h.type === 'hood') : [];

			// set status to hood/zone
			for (var i = 0; i < hoods.length; i++) {
				let hood = hoods[i];
				hood.active = false; // reset
				for (var k = 0; k < zones.length; k++) {
					if (zones[k].name === hood.name) {
						hood.active = true;
					}
				}

				for (var j = 0; j < hood.hoods.length; j++) {
					hood.hoods[j].active = false; // reset
					if (hood.active) {
						hood.hoods[j].active = true;
					} else {
						for (var l = 0; l < neighborhoods.length; l++) {
							if (neighborhoods[l].id == hood.hoods[j].id) {
								hood.hoods[j].active = true;
							}
						}
					}
				}
			}
			return hoods;
		};

		this.stopEnter = (e) => {
			if (e.keyCode === 13 && this.selectedItemIndex !== -1) { // 13-enter
				e.preventDefault();
				e.stopPropagation();
				this.selectItem(this.resultsItems[this.selectedItemIndex]);
				e.target.blur();
			}
		};

		this.getAllIndexes = (arr, val) => {
			var arrLower = arr.toLowerCase();
			var valLower = val.toLowerCase();
			var indexes = [], i = -1;
			while ((i = arrLower.indexOf(valLower, i+1)) != -1){
				indexes.push(i);
			}
			return indexes;
		};

		this.handleFocus = () => {
			this.searching = true; 

			if (this.tmpWelcomeSearch) {
				this.welcomeSearch = this.tmpWelcomeSearch;
				this.tmpWelcomeSearch = ''; 
			}

			this.placeholderAuto = this.placeholderAutocomplete.replace(/'/g, '"'); 

			// hide sub menu if open
			// document.fireEvent('hideSubMenu');
		};


		this.submitRecentSearch = (url) => {
			this.sendTrack(this.categoryTrack, 'Recent', '');
			$timeout(() => {
				$window.location.href = url;
			}, this.trackingDelay);
		};

		this.submitAdvancedSearch = () => {
			let url = this.activeSearch === 'searchsales' ? this.searchBuyApartmentsUrl : this.searchRentApartmentsUrl;
			let label = this.activeSearch === 'searchsales' ? 'sale' : 'rent';

			this.submit(url, 'Advanced-search', label);
		};

		this.submitSearch = () => {
			let action = this.activeSearch === 'searchsales' ? 'Buy' : 'Rent';
			this.submit(this.urlSearch(), action + '-search');
		};

		// this.submitHood = (url, action) => {
		// 	let trackAction = 'Hood';
		// 	let nbHoods = this.countNeighborhoods();
		// 	if (nbHoods > 1) {
		// 		trackAction += 's';
		// 	}
		// 	trackAction += '-' + action;

		// 	this.submit(url, trackAction);
		// };

		this.submitHood = (hood) => {
			let trackAction = 'Hood';
			let url = '';
			// let nbHoods = this.countNeighborhoods();
			// if (nbHoods > 1) {
			// 	trackAction += 's';
			// }
			// trackAction += '-' + action;

			if (this.lastSearch === 'searchsales') {
				url = hood.url.for_sale.url;
			} else if (this.lastSearch === 'searchrentals') {
				url = hood.url.for_rent.url;;
			}

			this.submit(url, trackAction);
		};

		this.submitBuilding = (url, action) => {
			let trackAction = 'Building';
			if (this.properties && this.properties.list.length > 1 && typeof action !== 'undefined') {
				trackAction += 's';
			}
			if (typeof action !== 'undefined') {
				trackAction += '-' + action;
			}

			this.submit(url, trackAction);
		};

		this.submit = (url, action, label) => {
			this.track(action, label);
			$timeout(() => {
				$window.location.href = url;
			}, this.trackingDelay);
		};

		this.urlSearch = () => { 
			let url = '';
			let minPrice = this.activeSearch === 'searchsales' ? this.filterPriceSales.options.min : this.filterPriceRentals.options.min;
			let maxPrice = this.activeSearch === 'searchsales' ? this.filterPriceSales.options.max : this.filterPriceRentals.options.max;
			let type = this.activeSearch === 'searchsales' ? 1 : 2;
			let encodedSearch = encodeURIComponent(this.welcomeSearch);
			let encodedHoods = this.hoods.filter(d => d.active).map(d => d.hoods[0].hood_zone_id).join(',');
			let extraParams = `&min_price=${minPrice}&max_price=${maxPrice}&sale_or_rent=${type}&zones=${encodedHoods}`;
			if (this.type === 'for-sale') {
				extraParams = '';
			}
			url = `${this.autocompleteSubmitUrl}?query=${encodedSearch}${extraParams}`;
			return url;
		};

		this.track = (action, lab) => {
			let label = '';
			let labelFinal = '';
			let labelPrice = '';
			let labelAutocomplete = '';
			let filterPrice = null;
			let hoodsSelected = this.neighborhoods && this.neighborhoods.list.length > 0 ? true : false;
			let keywordSelected = this.properties && this.properties.list.length > 0 ? true : false;

			if (lab) {
				labelFinal = label;
			} else {
				if (this.activeSearch === 'searchsales') {
					label += 'Buy';
					filterPrice = this.filterPriceSales;
				} else if (this.activeSearch === 'searchrentals') {
					label += 'Rent';
					filterPrice = this.filterPriceRentals;
				}

				if (this.type !== 'top-nav') {
					if (filterPrice && filterPrice.options.min === filterPrice.options.keys[0] && filterPrice.options.max === filterPrice.options.keys[filterPrice.options.keys.length-1]) {
						labelPrice = 'no-price';
					} else {
						labelPrice = 'price';
					}
				}

				if (hoodsSelected && keywordSelected) {
					labelAutocomplete = 'mix';
				} else if (hoodsSelected) {
					labelAutocomplete = 'hood';
				} else if (keywordSelected) {
					labelAutocomplete = 'key';
				}

				if (labelAutocomplete || labelPrice === 'price') {
					labelFinal = label + (labelAutocomplete ? '-' + labelAutocomplete : '' ) + (labelPrice ? '-' + labelPrice : '' );
				} else {
					labelFinal = label + '-default';
				}
			}

			this.sendTrack(this.categoryTrack, action, labelFinal);
		};

		this.sendTrack = (category, action, label) => {
			let search = this.welcomeSearch;
			for (let i = 0; i < this.hoods.length; i++) {
				let regExp = new RegExp(this.hoods[i].name, 'ig');
				search = search.replace(regExp, 'matchedHood').trim();
			}
			let value = search ? search.split(/\s+/).length : 0;
			_gaq.push(['_trackEvent', category, action, label, value, true]);
		};

		this.countNeighborhoods = () => {
			let nbHoods = 0;
			for (var i = 0; i < this.neighborhoods.list.length; i++) {
				if (this.neighborhoods.list[i].hoods) {
					nbHoods += this.neighborhoods.list[i].hoods;
				} else {
					nbHoods++;
				}
			}
			return nbHoods;
		};
	}]
});
